import { Meta } from "@/shared/components";
import { ProductPurchases } from "@/admin/features/productPurchases";

export function ProductPurchasesPage() {
  return (
    <>
      <Meta title="Покупки" />
      <ProductPurchases />
    </>
  );
}
